exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "div.provider-panel--2Qixi6jKyHyB12-yAf363x {\n  color: #265b91;\n}\n\ndiv.provider-panel--2Qixi6jKyHyB12-yAf363x a.provider-panel--3MXajd4_5m9oUi_5KZIIEr {\n  cursor: pointer;\n  font-weight: 500;\n}\n", ""]);

// exports
exports.locals = {
	"providerNameContainer": "provider-panel--2Qixi6jKyHyB12-yAf363x",
	"providerNameContainer": "provider-panel--2Qixi6jKyHyB12-yAf363x",
	"providerName": "provider-panel--3MXajd4_5m9oUi_5KZIIEr",
	"providerName": "provider-panel--3MXajd4_5m9oUi_5KZIIEr"
};